<!-- 首页组件 -->
<template>
    <div class="lrbg-container">
        <div class="text-box">
            <!-- 渐变文字·标题 -->
            <div class="line-text">
                <div class="text01">Chair</div>
                <div class="text02">conference</div>
            </div>
            <!-- 网站描述 -->
            <div class="desc-text">
                <div>An ideal platform for conference submissions</div>
                <div>Ensure that your submission process is simple and efficient</div>
            </div>
            <div class="btn">
                <el-button type="primary" size="large" @click="() => { $router.push('/common/newconference'); $store.commit('setMenuItemIndex', '5') }">Create Conference</el-button>
                <el-button type="primary" plain size="large" @click="() => { $router.push('/common/myconferences'); $store.commit('setMenuItemIndex', '1') }">Submit Immediately</el-button>
            </div>
        </div>
        <div class="img-box">
            <img src="../../public/img/index.png">
        </div>
    </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.lrbg-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .text-box {
        width: 50%;
        height: 230px;
        .line-text {
            display: flex;
            align-items: center;
            margin-bottom: 15px;

            .text01 {
                margin-right: 30px;
                font-size: 70px;
                background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 79, 129));
                -webkit-background-clip: text;
                background-clip: text;
                color: transparent;
            }

            .text02 {
                font-size: 70px;
                background-image: linear-gradient(to right, rgb(0, 162, 255), rgba(98, 0, 255, 0.534));
                -webkit-background-clip: text;
                background-clip: text;
                color: transparent;
            }
        }

        .desc-text {
            div:nth-child(1) {
                color: #6B6B6b;
                margin-bottom: 10px;
            }

            div:nth-child(2) {
                color: #6B6B6b;
                margin-bottom: 30px;
            }
        }

        .btn {
            .el-button {
                width: 176px;
                margin-right: 10px;
            }
        }
    }
    .img-box{
        width: 47%;
        height: 230px;
        display: flex;
        flex-direction: column-reverse;
        img{
            width: 100%;
            mask-image: linear-gradient(to bottom, transparent, black 2%, black 80%, transparent);
            border-radius: 10px;
            
        }
    }

}</style>